<template>
  <div>
    <Navbar/>
    <h4></h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idAlergia" class="form-label">IdAlergia</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idAlergia" name="idAlergia" v-model="datoAlergia.idAlergia" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombre" class="form-label">Nombre</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="nombre" name="nombre" v-model="datoAlergia.nombre" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="descripcion" class="form-label">Descripción</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="descripcion" name="descripcion" v-model="datoAlergia.descripcion" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="tipo" class="form-label">Tipo</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="tipo" name="tipo" v-model="datoAlergia.tipo" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <button type="submit" class="btn btn-light" @click.prevent="guardarAlergia" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditAlergia" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
<div class="busqueda-bar mb-3">
  <div class="busqueda-campo busqueda-campo--lg">
    <label class="form-label">Nombre</label>
    <input type="text" class="form-control form-control-sm"
           v-model="nombreBusqueda"
           @keyup.enter="getDataPagina(1)"
           style="text-transform:uppercase">
  </div>
  <button type="button" class="btn btn-primary btn-icono"
          @click.prevent="getDataPagina(1)" title="Buscar">
    <span class="material-symbols-outlined">search</span>
    Buscar
  </button>
  <button type="button" class="btn btn-outline-secondary btn-icono"
          @click.prevent="getDataPaginaTodos(1)" title="Todos">
    <span class="material-symbols-outlined">auto_awesome_motion</span>
  </button>
  <button type="button" class="btn btn-outline-success btn-icono"
          data-bs-toggle="modal" data-bs-target="#ventanaModal"
          @click="abrirModalCrear" title="Nuevo registro">
    <span class="material-symbols-outlined">add_box</span>
    Nuevo
  </button>
</div>
<DataTable
  :data="alergiaperss"
  :columns="columnas"
  idField="idAlergiaPers"
  :mostrarBotonTodos="false"
  :mostrarBotonNuevo="false"
  :mostrarBotonExcel="false"
  :mostrarEditar="true"
  :mostrarVer="true"
  :mostrarEliminar="true"
  mensajeVacio="No hay registros disponibles."
  @refresh="getDataPaginaTodos(1)"
  @edit="row => abrirModalEditar(row.idAlergiaPers)"
  @view="row => abrirEditarDet(row.idAlergiaPers)"
  @delete="row => deleteAlergiaPers(row.idAlergiaPers)"
/>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idAlergiaPers" class="form-label">IdAlergiaPers</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idAlergiaPers" name="idAlergiaPers" v-model="datoAlergiaPers.idAlergiaPers" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idPersona" class="form-label"> Persona</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idPersona" name="idPersona" v-model="datoAlergiaPers.idPersona">
                      <option v-for="persona in personas" :value="persona.idPersona" :key="persona.idPersona">
                        {{ persona.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idAlergia" class="form-label">IdAlergia</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idAlergia" name="idAlergia" v-model="datoAlergiaPers.idAlergia" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaReg" name="fechaReg" v-model="datoAlergiaPers.fechaReg" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaDiag" class="form-label">FechaDiag</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaDiag" name="fechaDiag" v-model="datoAlergiaPers.fechaDiag" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="severidad" class="form-label">Severidad</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="severidad" name="severidad" v-model="datoAlergiaPers.severidad" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="observacion" class="form-label">Observación</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="observacion" name="observacion" v-model="datoAlergiaPers.observacion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
        <button type="submit" class="btn btn-light" @click.prevent="guardarAlergiaPers" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditAlergiaPers" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

    <Footer/>
  </div>
</template>
<script>
import Navbar from '../../components/Navbar.vue'
import Footer from '../../components/Footer.vue'
import DataTable from '@/components/DataTable.vue'
import { validarForm } from '../../modules/validacionesForms.js';
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Navbar, Footer, DataTable
  },
  data () {
    return {
// Variables master
      alergias : [],
      datoAlergia : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idAlergia: '',
// Variables master
// Variables details
      alergiaperss : [],
      datoAlergiaPers : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      personas : [],
//      alergias : [],
      modalWindow: true,
// Variables details
    columnas: [
      { field: 'idAlergiaPers', label: 'ID' },
      { field: 'alergiaNombre', label: 'Alergia' },
      { field: 'severidad',     label: 'Severidad' },
      { field: 'observacion',   label: 'Observación' },
      { field: 'estado',        label: 'Estado' },
      { field: 'fechaDiag',     label: 'Fecha Diag.',
        format: v => this.getFormattedDate(v) },
    ],
    }
  },
  mounted () {
    this.p_idAlergia = this.$route.params.p_idalergia
    this.abrirEditar(this.p_idAlergia)
    this.getDataPagina(this.paginaActual)
  },
  methods : {
// Procedimientos master
    validarForm(){
      const requiredFields = [
        'nombre'
        ,'descripcion'
        ,'tipo'
      ];
      const requiredFieldsText = [
        'nombre'
        ,'descripcion'
        ,'tipo'
      ];
      return validarForm(this.datoAlergia, requiredFields, requiredFieldsText);
    },
    async guardarAlergia(){
      if(this.validarForm() === 1){
        try {
          await api.post('/alergias', this.datoAlergia)
          swal("Correcto!", "Alergia creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditAlergia(){
      if(this.validarForm() === 1){
        try {
          await api.post('/alergias', this.datoAlergia)
          swal("Correcto!", "Alergia creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoAlergia={}
      this.titulo   = 'Crear '
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idAlergia){
      this.modalWindow = true
      if(idAlergia != null){    
           api.get('/vwalergias/'+idAlergia).then(resp=>{
          this.datoAlergia = resp.data;
           });
      }
      this.titulo   = 'Editar '
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarAlergia(){
      this.$router.push('/Alergia')
    },
// Procedimientos master
// Procedimientos detalle
    totalPaginas(){
      return Math.ceil(this.alergiaperss.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwalergiaperss/nombre/'+this.nombreBusqueda).then(response=>{
          this.alergiaperss=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.alergiaperss.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwalergiaperss').then(response=>{
      this.alergiaperss=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.alergiaperss.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      const requiredFields = [
        'nombre'
        ,'descripcion'
        ,'tipo'
      ];
      const requiredFieldsText = [
        'nombre'
        ,'descripcion'
        ,'tipo'
      ];
      return validarForm(this.datoAlergia, requiredFields, requiredFieldsText);
    },
    async guardarAlergiaPers(){
      if(this.validarForm() === 1){
        try {
          this.datoAlergiaPers.idAlergia = this.datoAlergia.idAlergia;
          await api.post('/alergiaperss', this.datoAlergiaPers)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "AlergiaPers creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditAlergiaPers(){
      if(this.validarForm() === 1){
        try {
          await api.post('/alergiaperss', this.datoAlergiaPers)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "AlergiaPers creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoAlergiaPers={}
      this.titulo   = 'Crear '
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idAlergiaPers){
      this.modalWindow = true
      if(idAlergiaPers != null){    
           api.get('/vwalergiaperss/'+idAlergiaPers).then(resp=>{
          this.datoAlergiaPers = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar '
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idAlergiaPers){
      this.modalWindow = true
      if(idAlergiaPers != null){
        this.$router.push('/alergiapersmd/'+idAlergiaPers)
      }
    },
    async deleteAlergiaPers (idAlergiaPers) {
      try{
        await api.delete('/alergiaperss/'+idAlergiaPers)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
fetchPersonas() {
  api.get('/personas').then(r => { this.personas = r.data })
},
fetchAlergias() {
  api.get('/alergias').then(r => { this.alergias = r.data })
},
  },
}
</script>

<style>
.busqueda-bar { display:flex; flex-wrap:wrap; align-items:flex-end; gap:10px; }
.busqueda-campo { display:flex; flex-direction:column; flex:1; min-width:130px; }
.busqueda-campo--lg { flex:3 1 260px; }
.busqueda-bar .form-label { font-size:12px; font-weight:500; margin-bottom:3px; color:#6c757d; }
.btn-icono { display:inline-flex; align-items:center; gap:5px; padding:6px 12px; flex-shrink:0; }
@media (max-width:576px) {
  .busqueda-campo, .busqueda-campo--lg { flex:1 1 100%; }
  .btn-icono { width:100%; justify-content:center; }
}
</style>